<template>
    <ul :class='"list list-" + $parent.model'>
        <router-link tag='li' :to='$parent.getOpenLink(null, item.id)' v-for="item in $parent.items.data" :key='item.id' :class='"list-" + $parent.model + "_item"'>
            <h2 class="h6"><strong>{{formatNameCompliant(item)}} <template v-if='item.gender || item.dob'>(<template v-if='item.gender'>{{item.gender.toUpperCase()}}</template><template v-if='item.dob'> {{item.dob | getAge}}</template>)</template></strong></h2>
			<span>{{item.email}}&nbsp;</span>
			<div v-if="is_network_admin()">{{item.provider.name}}</div>
        </router-link>
    </ul>
</template>

<script>
    export default {
        props: [
        ],
        data: function() {
            return {
			//	item: 'test'
			};
        },
        methods: {
           
        }
    }
</script>
